import { SortDirection } from '@factorialco/deprecated-design-system'
import { isEmpty, orderBy } from 'lodash'

import { matchText } from 'modules/core/lib/stringUtils'

import type CodeForm from 'modules/payroll_integrations/components/Form/form'
import codes from 'modules/payroll_integrations/store/collections/codes'

const SortAttributes = {
  concept: 'concept',
  value: 'value',
}

export async function loadCodes(integration: string) {
  return await codes.fetch({
    data: {
      integration: integration,
    },
  })
}

export function filterItems(items: CodeForm[], filter: string): CodeForm[] {
  return items.filter((item: CodeForm) => {
    return isEmpty(filter) || matchText(filter, item.get('codeable_type').value)
  })
}

export function searchItems(forms: CodeForm[], search: string): CodeForm[] {
  return forms.filter((form: CodeForm) => {
    return isEmpty(search) || matchText(search, form.get('codeable_name').value)
  })
}

export function orderItems(
  forms: CodeForm[],
  attribute: string,
  direction: SortDirection
): CodeForm[] {
  const ord = orderBy(
    forms,
    [
      (formCode: CodeForm) => {
        if (!attribute || attribute === SortAttributes.concept) {
          return formCode.element.position
        }

        if (attribute === SortAttributes.value) {
          return formCode.fields.codeable_name?.value
        }
      },
    ],
    [direction]
  )

  return ord
}
